import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, MessageSquare } from "lucide-react";
import { useLang } from "../i18n";

// Mobile-only sticky bottom CTA. Appears after the first scroll, never on the page it links to.
export const StickyCTA = () => {
  const { pathname } = useLocation();
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 260);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.toggle("nv-sticky-on", show);
    return () => document.body.classList.remove("nv-sticky-on");
  }, [show]);

  const isHse = pathname === "/hse";
  const buttons = [
    { id: "contact", to: "/contact", label: t.sticky.contact, Icon: MessageSquare, primary: false },
    isHse
      ? { id: "hse", to: "/hse#hse-request", label: t.sticky.hse, Icon: ArrowRight, primary: true }
      : { id: "manpower", to: "/for-employers#request", label: t.sticky.manpower, Icon: ArrowRight, primary: true },
  ].filter((b) => !(b.id === "contact" && pathname === "/contact") && !(b.id === "manpower" && pathname === "/for-employers"));

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
          className="nv-sticky-cta fixed inset-x-0 bottom-0 z-40 border-t border-[#C8D3DB] bg-[#F4F6F8]/92 px-4 pt-3 pb-safe backdrop-blur-xl lg:hidden"
          data-testid="sticky-cta"
        >
          <div className="mx-auto flex max-w-2xl gap-3 pb-3">
            {buttons.map(({ id, to, label, Icon, primary }) => (
              <Link
                key={id}
                to={to}
                data-testid={`sticky-cta-${id}`}
                className={`inline-flex min-h-[50px] items-center justify-center gap-2 px-3 text-sm font-semibold transition-transform active:scale-[0.98] ${
                  primary ? "flex-[1.35] bg-gradient-brand text-white" : "flex-1 border border-[#0E1B24]/60 text-[#0E1B24]"
                }`}
              >
                <Icon size={16} className="shrink-0" /> <span className="truncate">{label}</span>
              </Link>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
